import { render } from "./ModifyWindows.vue?vue&type=template&id=7075f74b"
import script from "./ModifyWindows.vue?vue&type=script&lang=js"
export * from "./ModifyWindows.vue?vue&type=script&lang=js"

import "./ModifyWindows.vue?vue&type=style&index=0&id=7075f74b&lang=postcss&scope=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__